import { InjectableRxStompConfig } from '@stomp/ng2-stompjs';
import { environment } from '../../../../environments/environment';
import { UUID } from 'angular2-uuid';
const _window: any = window;
let url = '';
const uuid = UUID.UUID().replace(/-/g, '').toLocaleUpperCase();
const taskBaseApi = environment.hasOwnProperty('taskModule') && environment['taskModule'] ? environment['taskModule']  : '';
const notificationBaseApi = environment.hasOwnProperty('notificationModule') && environment['notificationModule'] ? environment['notificationModule']  : '';

if (environment.production) {
  let host = 'ws://' + window.location.host;
  if (window.location.protocol === 'https:') {
    host = 'wss://' + window.location.host;
  }
  if (notificationBaseApi) {
    url = host + notificationBaseApi + '/batchSocket';
  } else {
    url = host + '/main-backend/batchSocket';
  }
} else {
  if (notificationBaseApi) {
    url = environment.SERVER_URL.replace('http', 'ws') + notificationBaseApi + '/batchSocket';
  } else {
    url = environment.SERVER_URL.replace('http', 'ws') + '/batchSocket';
  }
}
console.log(environment.production, notificationBaseApi, url);
export const myRxStompConfig: InjectableRxStompConfig = {
  // Which server?
  brokerURL: url,

  // Headers
  // Typical keys: login, passcode, host
  connectHeaders: {
    login: 'guest',
    passcode: 'guest',
    businessCode: 'admin'
  },

  // How often to heartbeat?
  // Interval in milliseconds, set to 0 to disable
  heartbeatIncoming: 0, // Typical value 0 - disabled
  heartbeatOutgoing: 20000, // Typical value 20000 - every 20 seconds

  // Wait in milliseconds before attempting auto reconnect
  // Set to 0 to disable
  // Typical value 500 (500 milli seconds)
  reconnectDelay: 500,

  beforeConnect: (): void => {},

  // Will log diagnostics on console
  // It can be quite verbose, not recommended in production
  // Skip this key to stop logging to console
  debug: (msg: string): void => {
    // console.log(msg);
  }
};
